var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useRef } from "react";
import { Row, Col, Button, MessageBanner, TextLink, } from "@folio/stripes/components";
import { useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { useResolvePublisher } from "../../hooks/title/useResolvePublisher";
import { firstOnix } from "../../utils/selectMappers";
import { useItemEditor } from "../../hooks/title/useItemEditor";
import { useContentRows } from "../../utils/toContentRows";
import { FormSectionModal } from "./FormSectionModal";
import { useFieldArrayErrors } from "../../hooks/useFieldArrayErrors";
import { EntityRowList } from "./EntityRowList";
import css from "./FormModal.module.css";
var TitlePublishersForm = function (_a) {
    var publisherFields = _a.publisherFields, appendPublisher = _a.appendPublisher, updatePublisher = _a.updatePublisher, removePublisher = _a.removePublisher, isOnlyPublisherGuarantor = _a.isOnlyPublisherGuarantor, publisherRoleItems = _a.publisherRoleItems, publisherRoleLoading = _a.publisherRoleLoading, publisherRoleStatus = _a.publisherRoleStatus, publisherOptions = _a.publisherOptions, onPublisherFilter = _a.onPublisherFilter, prefillMunicipalityFromPublisher = _a.prefillMunicipalityFromPublisher;
    var formatMessage = useIntl().formatMessage;
    var _b = useResolvePublisher(), resolvePublisherById = _b.resolvePublisherById, getCachedPublisher = _b.getCachedPublisher;
    var getValues = useFormContext().getValues;
    var errorMessages = useFieldArrayErrors("titlePublishers");
    var _c = useItemEditor({
        appendItem: function (item) {
            var _a;
            appendPublisher({
                publisher: item.publisher,
                role: (_a = item.role) !== null && _a !== void 0 ? _a : firstOnix(publisherRoleItems),
            });
            prefillMunicipalityFromPublisher(item.publisher);
        },
        updateItem: function (index, item) {
            updatePublisher(index, item);
            prefillMunicipalityFromPublisher(item.publisher);
        },
        createEmpty: function () { return ({
            publisher: undefined,
            role: firstOnix(publisherRoleItems),
        }); },
    }), isOpen = _c.isOpen, isEditing = _c.isEditing, editingIndex = _c.editingIndex, draft = _c.draft, setDraft = _c.setDraft, openEditor = _c.openEditor, closeEditor = _c.closeEditor, saveItem = _c.saveItem;
    var publisherRequestIdRef = useRef(0);
    var handlePublisherSelect = function (publisherId) { return __awaiter(void 0, void 0, void 0, function () {
        var requestId, cachedPublisher, fullPublisher, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestId = ++publisherRequestIdRef.current;
                    cachedPublisher = getCachedPublisher(publisherId);
                    setDraft(function (prev) { return (__assign(__assign({}, prev), { publisher: cachedPublisher !== null && cachedPublisher !== void 0 ? cachedPublisher : { id: publisherId } })); });
                    if (!(cachedPublisher !== null && cachedPublisher !== void 0)) return [3 /*break*/, 1];
                    _a = cachedPublisher;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, resolvePublisherById(publisherId)];
                case 2:
                    _a = (_b.sent());
                    _b.label = 3;
                case 3:
                    fullPublisher = _a;
                    if (requestId !== publisherRequestIdRef.current)
                        return [2 /*return*/];
                    if (fullPublisher && fullPublisher !== cachedPublisher) {
                        setDraft(function (prev) { return (__assign(__assign({}, prev), { publisher: fullPublisher })); });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var contentData = useContentRows(publisherFields);
    var isDisabledRow = function (index) {
        return isOnlyPublisherGuarantor && index === 0;
    };
    var columns = [
        {
            name: formatMessage({
                id: "ui-br-agency.title.publishers.publisher.label",
            }),
            cellRenderer: function (row) {
                var _a, _b;
                var name = ((_a = row.publisher) === null || _a === void 0 ? void 0 : _a.name) || "-";
                var sourceId = (_b = row.publisher) === null || _b === void 0 ? void 0 : _b.sourceId;
                return sourceId && name !== "-" ? (React.createElement(TextLink, { href: "/bragency/publishers/detail?sourceId=".concat(sourceId), target: "_blank", rel: "noopener noreferrer" }, name)) : (name);
            },
        },
        {
            name: formatMessage({ id: "ui-br-agency.title.publishers.role.label" }),
            cellRenderer: function (row) { var _a; return ((_a = row.role) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 }, publisherFields.length > 0 ? (React.createElement(EntityRowList, { data: contentData, columns: columns, onEdit: function (row) {
                    return openEditor(getValues("titlePublishers.".concat(row._index)), row._index);
                }, onDelete: function (row) { return removePublisher(row._index); }, canDelete: function (row) {
                    return publisherFields.length > 1 && !isDisabledRow(row._index);
                } })) : (React.createElement("div", { className: css.emptyState },
                React.createElement(FormattedMessage, { id: "ui-br-agency.title.publishers.empty" }))))),
        errorMessages.length > 0 && (React.createElement(Row, { "data-error-field": "titlePublishers" },
            React.createElement(Col, { xs: 12 },
                React.createElement(MessageBanner, { type: "error", className: css.tableErrorBanner }, errorMessages.map(function (msg) { return (React.createElement("div", { key: msg }, msg)); }))))),
        React.createElement(FormSectionModal, { open: isOpen, isEditing: isEditing, draft: draft, onDraftChange: setDraft, onSave: saveItem, onClose: closeEditor, addLabelId: "ui-br-agency.title.publishers.form.add.title", editLabelId: "ui-br-agency.title.publishers.form.edit.title", size: "large", fields: (function () {
                var disabled = editingIndex !== null && isDisabledRow(editingIndex);
                return [
                    {
                        key: "publisher",
                        labelId: "ui-br-agency.title.publisher.label",
                        type: "selection",
                        required: true,
                        colSpan: 6,
                        selectOptions: publisherOptions,
                        onFilter: onPublisherFilter,
                        onSelect: handlePublisherSelect,
                        disabled: disabled,
                    },
                    {
                        key: "role",
                        labelId: "ui-br-agency.title.publisher.role.label",
                        type: "onix",
                        required: true,
                        colSpan: 6,
                        dataOptions: publisherRoleItems !== null && publisherRoleItems !== void 0 ? publisherRoleItems : [],
                        loading: publisherRoleLoading,
                        codetableStatus: publisherRoleStatus,
                        disabled: disabled,
                    },
                ];
            })(), validate: function (d) { var _a, _b; return !!((_a = d.publisher) === null || _a === void 0 ? void 0 : _a.id) && !!((_b = d.role) === null || _b === void 0 ? void 0 : _b.value); } }),
        React.createElement(Row, { className: css.actions },
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return openEditor(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.title.form.add.publisher" }))))));
};
export default TitlePublishersForm;
